import { PrimaryDiagnosisDetails } from "../../../../data-model/medicalPaOrdersModel";
import { TableData } from "../types";
import { ENTER_MANUALLY_OPTION } from "./saveNewPrimaryDiagnosisCode";

/** State updates produced when resolving the initial primary Dx selection. */
export interface InitialPrimaryDxSelection {
  defaultPrimaryCode: string;
  selectedPrimaryCode: string;
  manualPrimaryCode: string;
  selectedPrimaryCodeDescription: string;
}

/**
 * Resolves the initial primary Dx selection from stack defaults and table options.
 *
 * @param defaultCode - Primary ICD code from submission data.
 * @param tableData - Patient Dx rows shown in the modal table.
 * @param primaryDiagnosisDetails - Existing submission diagnosis entries.
 * @return Initial selection state, or `null` when default code is empty.
 */
export const resolveInitialPrimaryDxSelection = (
  defaultCode: string,
  tableData: TableData[],
  primaryDiagnosisDetails: PrimaryDiagnosisDetails[] | undefined,
): InitialPrimaryDxSelection | null => {
  if (!defaultCode.trim()) {
    return null;
  }

  const isDefaultInOptions = tableData.some(
    (entry) => entry.icd10_code === defaultCode,
  );

  if (isDefaultInOptions) {
    return {
      defaultPrimaryCode: defaultCode,
      selectedPrimaryCode: defaultCode,
      manualPrimaryCode: "",
      selectedPrimaryCodeDescription: "",
    };
  }

  const matchingDiagnosis = primaryDiagnosisDetails?.find(
    (item) => item.icd_code === defaultCode,
  );

  return {
    defaultPrimaryCode: defaultCode,
    selectedPrimaryCode: ENTER_MANUALLY_OPTION,
    manualPrimaryCode: defaultCode,
    selectedPrimaryCodeDescription: matchingDiagnosis?.icd_description ?? "",
  };
};
